module.exports = [
  { name: "MHFG / BK", value: "FGBK", options: ["BK", "FG"] },
  { name: "MHTB", value: "MHTB", options: ["TB"] },
  { name: "MHIR", value: "MHIR", options: ["IR"] }
];



// WEBPACK FOOTER //
// ./src/rules/entities.js